module.exports = {
      id: "contact-usage",
      viewBox: "0 0 27.555 27.555",
      url: __webpack_public_path__ + "assets/sprite-28816f.svg#contact-usage",
      toString: function () {
        return this.url;
      }
    }